import { Controller } from "@hotwired/stimulus"

// Toggles a dropdown menu for platform-specific CSV downloads.
//
// Usage:
//   <div data-controller="platform-dropdown">
//     <button data-action="click->platform-dropdown#toggle">Download</button>
//     <div data-platform-dropdown-target="menu" class="hidden">
//       <a href="...">Platform A</a>
//       <a href="...">Platform B</a>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._outsideClickHandler = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this._outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
